module.exports = __webpack_public_path__ + "img/pickleball-pala-pelotas.6423151a.jpg";